import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import { Summary } from '@components';
import { iFVSFormValues, getSummaryScreen } from '@services/FVSService';

function FVSStep23(): ReactElement {
  const { values }: { values: iFVSFormValues } = useFormikContext();
  return (
    <div>
      <Summary summaryFields={getSummaryScreen(values)} />
    </div>
  );
}

export default FVSStep23;
